import { Globe } from 'lucide-react'

import { REGIONS_BY_ID } from '@snootsvet/shared'

import { EditableField, EditableValue } from '@/customer/components/editable-field'
import { useGetMe } from '@/customer/hooks/use-get-me'

/**
 * Portal region field.
 *
 * Read-only row showing the member's region as a flag + full name
 * (e.g. "🇬🇧 United Kingdom"). Region is set server-side at signup
 * and can't be changed from the portal, so no edit affordance.
 */
export function RegionProfileField() {
  const me = useGetMe()
  const member = me.data?.member
  if (!member) return null

  const region = REGIONS_BY_ID[member.region]

  return (
    <EditableField label="Region" icon={Globe}>
      <EditableValue>
        <span aria-hidden="true">{region.flag}</span> {region.name}
      </EditableValue>
    </EditableField>
  )
}
